import React from "react";
import { useReducer } from "react";
import authContext from "./authContext";

const defaultState = {
	inputItem: "",
};

const reducer = (state, action) => {
	if (action.type === "GetInput") {
		// console.log("val", action.val);
		let updatedItems = {};
		updatedItems = action.val.data;
		console.log(updatedItems);
		return {
			inputItem: updatedItems,
		};
	}
	return defaultState;
};

const ContextProvider = (props) => {
	const [states, dispatch] = useReducer(reducer, defaultState);
	const handleVal = (val) => {
		dispatch({ type: "GetInput", val: val });
	};
	const helperContext = {
		SearchVal: handleVal,
		inputItem: states.inputItem,
	};
	return (
		<authContext.Provider value={helperContext}>
			{props.children}
		</authContext.Provider>
	);
};

export default ContextProvider;
